import styled from 'styled-components'

export const BarChartWrapper = styled.div`
	min-height: 230px;
	position: relative;
	height: 100%;
	width: 100%;
`
